import { render, staticRenderFns } from "./SoftwareComponentsView.vue?vue&type=template&id=446693d2&"
import script from "./SoftwareComponentsView.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports